export const MIGRATED_NODE_TYPES = [
  'commandTextNode',
  'scripting',
  'apiCaller',
  'audioReaderNode',
  'mathFunction',
  'sqlQuerier',
  'counterNode',
  'outputController',
] as const;

export type MigratedNodeType = (typeof MIGRATED_NODE_TYPES)[number];

export function isMigratedNode(nodeType: string): boolean {
  return (MIGRATED_NODE_TYPES as readonly string[]).includes(nodeType);
}
